"use strict";
// Uncomment the next lines to use your game instance in the browser
const $09e991522ca7e64e$var$initialState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        this.initialState = initialState;
        // eslint-disable-next-line no-console
        console.log(initialState);
    }
    moveLeft() {}
    moveRight() {}
    moveUp() {}
    moveDown() {}
    /**
   * @returns {number}
   */ getScore() {}
    /**
   * @returns {number[][]}
   */ getState() {}
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {}
    /**
   * Starts the game.
   */ start() {}
    /**
   * Resets the game.
   */ restart() {}
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports($09e991522ca7e64e$var$initialState);
let $09e991522ca7e64e$var$filledCells = 0;
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
let $09e991522ca7e64e$var$state = structuredClone($09e991522ca7e64e$var$initialState);
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$button.className === "button restart") $09e991522ca7e64e$var$game.restart();
    if ($09e991522ca7e64e$var$button.className === "button start") $09e991522ca7e64e$var$game.start();
});
document.addEventListener("keydown", (e)=>{
    switch(e.keyCode){
        case 37:
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case 38:
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case 39:
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case 40:
            $09e991522ca7e64e$var$game.moveDown();
    }
    if ([
        ...$09e991522ca7e64e$var$cells
    ].some((cell)=>cell.textContent === "2048")) $09e991522ca7e64e$var$messageWin.className = "message message-win";
    if ($09e991522ca7e64e$var$filledCells === $09e991522ca7e64e$var$cells.length && !$09e991522ca7e64e$var$canGameContinue()) $09e991522ca7e64e$var$messageLose.className = "message message-lose";
});
$09e991522ca7e64e$var$game.start = ()=>{
    $09e991522ca7e64e$var$messageStart.className = "message message-start hidden";
    $09e991522ca7e64e$var$messageLose.className = "message message-lose hidden";
    $09e991522ca7e64e$var$messageWin.className = "message message-win hidden";
    $09e991522ca7e64e$var$button.className = "button restart";
    $09e991522ca7e64e$var$button.textContent = "Restart";
    $09e991522ca7e64e$var$addRandomNumInCells();
    $09e991522ca7e64e$var$addRandomNumInCells();
};
$09e991522ca7e64e$var$game.restart = ()=>{
    $09e991522ca7e64e$var$filledCells = 0;
    $09e991522ca7e64e$var$score.textContent = 0;
    $09e991522ca7e64e$var$state = structuredClone($09e991522ca7e64e$var$initialState);
    $09e991522ca7e64e$var$game.start();
};
$09e991522ca7e64e$var$game.getScore = ()=>{
    let totalScore = 0;
    for (const raw of $09e991522ca7e64e$var$state)totalScore += raw.reduce((sum, num)=>sum + num);
    return totalScore;
};
function $09e991522ca7e64e$var$addRandomNumInCells() {
    let randomRowIndex = Math.round(Math.random() * 3);
    let randomColumnIndex = Math.round(Math.random() * 3);
    const cellTextContent = Math.random() < 0.1 ? 4 : 2;
    while($09e991522ca7e64e$var$state[randomRowIndex][randomColumnIndex] > 0 && $09e991522ca7e64e$var$filledCells < $09e991522ca7e64e$var$cells.length){
        randomRowIndex = Math.round(Math.random() * 3);
        randomColumnIndex = Math.round(Math.random() * 3);
    }
    $09e991522ca7e64e$var$state[randomRowIndex][randomColumnIndex] = cellTextContent;
    $09e991522ca7e64e$var$filledCells++;
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$changeRealState();
}
function $09e991522ca7e64e$var$changeRealState() {
    for(let i = 0; i < $09e991522ca7e64e$var$cells.length; i++){
        $09e991522ca7e64e$var$cells[i].textContent = $09e991522ca7e64e$var$state[Math.floor(i / 4)][i % 4] === 0 ? "" : $09e991522ca7e64e$var$state[Math.floor(i / 4)][i % 4];
        $09e991522ca7e64e$var$cells[i].className = $09e991522ca7e64e$var$state[Math.floor(i / 4)][i % 4] === 0 ? "field-cell" : `field-cell field-cell--${$09e991522ca7e64e$var$state[Math.floor(i / 4)][i % 4]}`;
    }
}
function $09e991522ca7e64e$var$canGameContinue() {
    let isSomethingChanged = false;
    for(let i = $09e991522ca7e64e$var$state.length - 2; i >= 0; i--){
        for(let j = 0; j < $09e991522ca7e64e$var$state[i].length; j++)if ($09e991522ca7e64e$var$state[i + 1][j] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0) isSomethingChanged = true;
    }
    for(let i = $09e991522ca7e64e$var$state.length - 1; i > 0; i--){
        for(let j = 0; j < $09e991522ca7e64e$var$state[i].length; j++)if ($09e991522ca7e64e$var$state[i - 1][j] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0) isSomethingChanged = true;
    }
    for(let i = 0; i < $09e991522ca7e64e$var$state.length; i++){
        for(let j = 1; j < $09e991522ca7e64e$var$state[i].length; j++)if ($09e991522ca7e64e$var$state[i][j - 1] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0) isSomethingChanged = true;
    }
    for(let i = 0; i < $09e991522ca7e64e$var$state.length; i++){
        for(let j = $09e991522ca7e64e$var$state[i].length - 2; j >= 0; j--)if ($09e991522ca7e64e$var$state[i][j + 1] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0) isSomethingChanged = true;
    }
    return isSomethingChanged;
}
$09e991522ca7e64e$var$game.moveDown = ()=>{
    let isSomethingChanged = false;
    const jWasUsed = [];
    for(let n = 0; n < $09e991522ca7e64e$var$state.length; n++){
        for(let i = $09e991522ca7e64e$var$state.length - 2; i >= 0; i--)for(let j = 0; j < $09e991522ca7e64e$var$state[i].length; j++){
            if ($09e991522ca7e64e$var$state[i + 1][j] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0 && jWasUsed.every((ind)=>ind !== j)) {
                if ($09e991522ca7e64e$var$state[0][j] !== 0 && $09e991522ca7e64e$var$state[3][j] !== 0 && $09e991522ca7e64e$var$state[0][j] === $09e991522ca7e64e$var$state[1][j] && $09e991522ca7e64e$var$state[2][j] === $09e991522ca7e64e$var$state[3][j]) {
                    $09e991522ca7e64e$var$state[3][j] = $09e991522ca7e64e$var$state[2][j] * 2;
                    $09e991522ca7e64e$var$state[2][j] = $09e991522ca7e64e$var$state[1][j] * 2;
                    $09e991522ca7e64e$var$state[1][j] = 0;
                    $09e991522ca7e64e$var$state[0][j] = 0;
                    isSomethingChanged = true;
                    jWasUsed.push(j);
                    $09e991522ca7e64e$var$filledCells -= 2;
                    continue;
                }
                $09e991522ca7e64e$var$state[i + 1][j] *= 2;
                $09e991522ca7e64e$var$state[i][j] = 0;
                isSomethingChanged = true;
                jWasUsed.push(j);
                $09e991522ca7e64e$var$filledCells--;
            }
            if ($09e991522ca7e64e$var$state[i + 1][j] === 0 && $09e991522ca7e64e$var$state[i][j] !== 0) {
                [$09e991522ca7e64e$var$state[i + 1][j], $09e991522ca7e64e$var$state[i][j]] = [
                    $09e991522ca7e64e$var$state[i][j],
                    $09e991522ca7e64e$var$state[i + 1][j]
                ];
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $09e991522ca7e64e$var$addRandomNumInCells();
};
$09e991522ca7e64e$var$game.moveUp = ()=>{
    let isSomethingChanged = false;
    const jWasUsed = [];
    for(let n = 0; n < $09e991522ca7e64e$var$state.length; n++){
        for(let i = $09e991522ca7e64e$var$state.length - 1; i > 0; i--)for(let j = 0; j < $09e991522ca7e64e$var$state[i].length; j++){
            if ($09e991522ca7e64e$var$state[i - 1][j] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0 && jWasUsed.every((ind)=>ind !== j)) {
                if ($09e991522ca7e64e$var$state[0][j] !== 0 && $09e991522ca7e64e$var$state[3][j] !== 0 && $09e991522ca7e64e$var$state[0][j] === $09e991522ca7e64e$var$state[1][j] && $09e991522ca7e64e$var$state[2][j] === $09e991522ca7e64e$var$state[3][j]) {
                    $09e991522ca7e64e$var$state[0][j] = $09e991522ca7e64e$var$state[1][j] * 2;
                    $09e991522ca7e64e$var$state[1][j] = $09e991522ca7e64e$var$state[2][j] * 2;
                    $09e991522ca7e64e$var$state[2][j] = 0;
                    $09e991522ca7e64e$var$state[3][j] = 0;
                    isSomethingChanged = true;
                    jWasUsed.push(j);
                    $09e991522ca7e64e$var$filledCells -= 2;
                    continue;
                }
                $09e991522ca7e64e$var$state[i - 1][j] *= 2;
                $09e991522ca7e64e$var$state[i][j] = 0;
                isSomethingChanged = true;
                jWasUsed.push(j);
                $09e991522ca7e64e$var$filledCells--;
            }
            if ($09e991522ca7e64e$var$state[i - 1][j] === 0 && $09e991522ca7e64e$var$state[i][j] !== 0) {
                [$09e991522ca7e64e$var$state[i - 1][j], $09e991522ca7e64e$var$state[i][j]] = [
                    $09e991522ca7e64e$var$state[i][j],
                    $09e991522ca7e64e$var$state[i - 1][j]
                ];
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $09e991522ca7e64e$var$addRandomNumInCells();
};
$09e991522ca7e64e$var$game.moveLeft = ()=>{
    let isSomethingChanged = false;
    const iWasUsed = [];
    for(let n = 0; n < $09e991522ca7e64e$var$state.length; n++){
        for(let i = 0; i < $09e991522ca7e64e$var$state.length; i++)for(let j = 1; j < $09e991522ca7e64e$var$state[i].length; j++){
            if ($09e991522ca7e64e$var$state[i][j - 1] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0 && iWasUsed.every((ind)=>ind !== i)) {
                if ($09e991522ca7e64e$var$state[i][0] !== 0 && $09e991522ca7e64e$var$state[i][3] !== 0 && $09e991522ca7e64e$var$state[i][0] === $09e991522ca7e64e$var$state[i][1] && $09e991522ca7e64e$var$state[i][2] === $09e991522ca7e64e$var$state[i][3]) {
                    $09e991522ca7e64e$var$state[i][0] = $09e991522ca7e64e$var$state[i][1] * 2;
                    $09e991522ca7e64e$var$state[i][1] = $09e991522ca7e64e$var$state[i][2] * 2;
                    $09e991522ca7e64e$var$state[i][2] = 0;
                    $09e991522ca7e64e$var$state[i][3] = 0;
                    isSomethingChanged = true;
                    iWasUsed.push(i);
                    $09e991522ca7e64e$var$filledCells -= 2;
                    continue;
                }
                $09e991522ca7e64e$var$state[i][j - 1] *= 2;
                $09e991522ca7e64e$var$state[i][j] = 0;
                isSomethingChanged = true;
                iWasUsed.push(i);
                $09e991522ca7e64e$var$filledCells--;
            }
            if ($09e991522ca7e64e$var$state[i][j - 1] === 0 && $09e991522ca7e64e$var$state[i][j] !== 0) {
                [$09e991522ca7e64e$var$state[i][j - 1], $09e991522ca7e64e$var$state[i][j]] = [
                    $09e991522ca7e64e$var$state[i][j],
                    $09e991522ca7e64e$var$state[i][j - 1]
                ];
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $09e991522ca7e64e$var$addRandomNumInCells();
};
$09e991522ca7e64e$var$game.moveRight = ()=>{
    let isSomethingChanged = false;
    const iWasUsed = [];
    for(let n = 0; n < $09e991522ca7e64e$var$state.length; n++){
        for(let i = 0; i < $09e991522ca7e64e$var$state.length; i++)for(let j = $09e991522ca7e64e$var$state[i].length - 2; j >= 0; j--){
            if ($09e991522ca7e64e$var$state[i][j + 1] === $09e991522ca7e64e$var$state[i][j] && $09e991522ca7e64e$var$state[i][j] !== 0 && iWasUsed.every((ind)=>ind !== i)) {
                if ($09e991522ca7e64e$var$state[i][0] !== 0 && $09e991522ca7e64e$var$state[i][3] !== 0 && $09e991522ca7e64e$var$state[i][0] === $09e991522ca7e64e$var$state[i][1] && $09e991522ca7e64e$var$state[i][2] === $09e991522ca7e64e$var$state[i][3]) {
                    $09e991522ca7e64e$var$state[i][3] = $09e991522ca7e64e$var$state[i][2] * 2;
                    $09e991522ca7e64e$var$state[i][2] = $09e991522ca7e64e$var$state[i][1] * 2;
                    $09e991522ca7e64e$var$state[i][1] = 0;
                    $09e991522ca7e64e$var$state[i][0] = 0;
                    isSomethingChanged = true;
                    iWasUsed.push(i);
                    $09e991522ca7e64e$var$filledCells -= 2;
                    continue;
                }
                $09e991522ca7e64e$var$state[i][j + 1] *= 2;
                $09e991522ca7e64e$var$state[i][j] = 0;
                isSomethingChanged = true;
                iWasUsed.push(i);
                $09e991522ca7e64e$var$filledCells--;
            }
            if ($09e991522ca7e64e$var$state[i][j + 1] === 0 && $09e991522ca7e64e$var$state[i][j] !== 0) {
                [$09e991522ca7e64e$var$state[i][j + 1], $09e991522ca7e64e$var$state[i][j]] = [
                    $09e991522ca7e64e$var$state[i][j],
                    $09e991522ca7e64e$var$state[i][j + 1]
                ];
                isSomethingChanged = true;
            }
        }
    }
    if (isSomethingChanged) $09e991522ca7e64e$var$addRandomNumInCells();
};


//# sourceMappingURL=index.79e1cde7.js.map
